import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VbVideoBannersComponent } from '../videoBanner/VbVideoBanners.Component';
import { VbImageLoadDirective } from '../shared/VbImageLoad.Directive';

import { NativeHlsStallDetectorDirective } from './NativeHlsStallDetector';
import { SafeStyleComponent } from './SafeStyle.Component';
import { VbMediaClickDirective } from './VbMediaClick.Directive';
import { VgChapterDisplayComponent } from './VgChapterDisplay.Component';
import { VgMediaComponent } from './VgMedia.Component';
import { VideogularComponent } from './Videogular.Component';

const components = [
	VbVideoBannersComponent,
	VgChapterDisplayComponent,
	VgMediaComponent,
	VideogularComponent
];

const directives = [
	NativeHlsStallDetectorDirective,
	VbMediaClickDirective
];

//TODO: Only export needed components.
const componentsAndDirectives = [...components, ...directives];

@NgModule({
	declarations: [...componentsAndDirectives, SafeStyleComponent],
	exports: componentsAndDirectives,
	imports: [
		CommonModule,
		VbImageLoadDirective
	]
})
export class VideogularModule {}
